<template>
  <!-- A drawn glyph, inline. The builder puts two or three beside every leg of
       every ticket, and a web-component icon per instance (IonIcon parses its
       SVG on mount) cost measurable main-thread time on the app shell's first
       paint. These are 16px, one stroke weight, currentColor. -->
  <svg class="glyph" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
    <template v-if="name === 'lock'">
      <rect x="3" y="7" width="10" height="7" rx="1.5" fill="currentColor" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" stroke-width="1.6" />
    </template>
    <template v-else-if="name === 'unlock'">
      <rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 4.9-.7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    </template>
    <path v-else-if="name === 'swap'" d="M2.5 5.5h10m-2.5-3 2.5 3-2.5 3M13.5 10.5h-10m2.5-3-2.5 3 2.5 3" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    <path v-else-if="name === 'plus'" d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    <path v-else-if="name === 'minus'" d="M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    <path v-else-if="name === 'check'" d="M3 8.5l3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    <template v-else-if="name === 'search'">
      <circle cx="7" cy="7" r="4.25" fill="none" stroke="currentColor" stroke-width="1.6" />
      <path d="M10.2 10.2L13.5 13.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </template>
    <path v-else-if="name === 'close'" d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
  </svg>
</template>

<script setup>
defineProps({ name: { type: String, required: true } });
</script>

<style scoped>
.glyph {
  flex: 0 0 auto;
  width: 1em;
  height: 1em;
}
</style>
